import { Route, Routes, Navigate, useLocation } from "react-router-dom"
import App from "../App"
import React, { useContext } from "react"
import AuthContext from "@/context/auth.context"
import DagsPage from "@pages/dags"
import AppLayout from "@components/layout"
import { ISidebarItems } from "@/types/layout"
import EtlDirectoryPage from "@pages/etlDirectory"
import AccessesPage from "@/pages/accesses"
import LicencesPage from "@pages/licences"
import GeoLevelPage from "@pages/geoLevel"
import OrganisationsPage from "@pages/organisations"

const ROUTES = {
  dags: "/dags",
  etlDirectory: "/etlDirectory",
  authenticate: "/authenticate",
  accesses: "/accesses",
  licences: "/licences",
  geolevel: "/geolevel",
  organisations: "/organisations",
}

const sidebarItems: ISidebarItems = [
  {
    name: "DAGS",
    key: "dags",
    route: ROUTES.dags,
  },
  {
    name: "ETL DIRECTORY",
    key: "etlDirectory",
    route: ROUTES.etlDirectory,
  },
  {
    name: "ACCESSES",
    key: "accesses",
    route: ROUTES.accesses,
  },
  {
    name: "LICENCES",
    key: "licences",
    route: ROUTES.licences,
  },
  {
    name: "GEO-LEVEL",
    key: "geolevel",
    route: ROUTES.geolevel,
  },
  {
    name: "ORGANISATIONS",
    key: "organisations",
    route: ROUTES.organisations,
  },
]

const Navigations: React.FunctionComponent = () => {
  const { token, removeUserToken, userName } = useContext(AuthContext)
  const { pathname } = useLocation()

  if (!token) {
    return (
      <Routes>
        <Route path={"*"} element={<Navigate to={"/"} />} />
        <Route path={"/"} element={<App />} />
      </Routes>
    )
  }

  return (
    <AppLayout
      sidebarItems={sidebarItems}
      selectedSideBar={pathname}
      onRemoveUserToken={removeUserToken}
      userName={userName}
    >
      <Routes>
        <Route path={"/"} element={<Navigate to={ROUTES.dags} />} />
        <Route path={ROUTES.dags} element={<DagsPage />} />
        <Route path={ROUTES.etlDirectory} element={<EtlDirectoryPage />} />
        <Route path={ROUTES.accesses} element={<AccessesPage />} />
        <Route path={ROUTES.licences} element={<LicencesPage />} />
        <Route path={ROUTES.geolevel} element={<GeoLevelPage />} />
        <Route path={ROUTES.organisations} element={<OrganisationsPage />} />
      </Routes>
    </AppLayout>
  )
}

export default Navigations
